<template>
  <div class="statusSelect" tabindex="0" @blur="open = false">
    <div @click="open = !open" :class="{ open: open }" class="selected">
      <span :class="`status-${selected}`">{{ statusLabels[selected] }}</span>
    </div>
    <div class="items" :class="{ selectHide: !open }">
      <div
        v-for="(label, key) of statusLabels"
        :key="key"
        @click="confirmChangeStatus(Number(key))"
        :class="`status-${key}`"
      >
        {{ label }}
      </div>
    </div>
  </div>

  <b-modal
    v-model="changeStatusModal"
    @keydown.enter="changeStatus"
    title="Are you sure?"
    class="questionModal"
    centered
    hide-footer
  >
    <p>
      Change coupon status to <strong>{{ statusLabels[newStatus] }}?</strong>
    </p>
    <div class="btnBl">
      <b-button @click="closeModal" variant="light">Cancel</b-button>
      <b-button @click="changeStatus" :disabled="loading" variant="danger" class="confirmBtn">
        <b-spinner v-if="loading" small variant="light" />
        <span v-else>Change status</span>
      </b-button>
    </div>
  </b-modal>
</template>

<script>
import { useActAdminApi } from '@/use/actAdminApi'
import { useErrorHandler } from '@/use/errorHandler'

export default {
  props: {
    id: Number,
    status: Number,
    project: {
      type: String,
      default: 'platfone'
    }
  },
  data() {
    return {
      changeStatusModal: false,
      statusLabels: {
        1: 'Active',
        2: 'Used',
        3: 'Disabled',
        4: 'Refunded'
      },
      selected: this.status,
      open: false,
      newStatus: null
    }
  },
  computed: {
    loading() {
      return this.$store.state.loaders.commonLoading
    }
  },
  watch: {
    status(val) {
      this.selected = val
    }
  },
  setup() {
    const { initApiInst, actPaymentCouponsApi } = useActAdminApi()
    const { handleCommonErrors } = useErrorHandler()
    return { initApiInst, actPaymentCouponsApi, handleCommonErrors }
  },
  methods: {
    confirmChangeStatus(status) {
      if (status === this.selected) return (this.open = false)
      this.newStatus = status
      this.changeStatusModal = true
    },
    async changeStatus() {
      try {
        this.$store.commit('loaders/setCommonLoading', true)
        await this.initApiInst()
        const resp = await this.actPaymentCouponsApi.updatePaymentCouponStatus(this.id, {
          updatePaymentCouponStatusRequest: { status: this.newStatus, project: this.project }
        })
        if (resp?.result === 'success') {
          this.selected = this.newStatus
          this.$store.commit('alert/add', {
            id: Date.now(),
            text: 'Coupon status successfully changed',
            timeout: 3000,
            type: 'success',
            name: 'status_changed'
          })
        }
      } catch (e) {
        this.handleCommonErrors(e)
      } finally {
        this.$store.commit('loaders/setCommonLoading', false)
        this.closeModal()
      }
    },
    closeModal() {
      this.open = false
      this.changeStatusModal = false
      this.newStatus = null
    }
  }
}
</script>

<style lang="scss" scoped>
.statusSelect {
  position: relative;
  width: 100%;
  min-width: 116px;
  text-align: left;
  outline: none;
  height: 38px;
  line-height: 38px;

  .selected {
    background-color: #fff;
    border-radius: 6px;
    border: 1px solid rgba(25, 22, 50, 0.12);
    color: #14142b;
    padding-left: 1em;
    cursor: pointer;
    user-select: none;
  }

  .selected.open {
    border-radius: 6px 6px 0 0;
  }

  .selected:after {
    position: absolute;
    content: '';
    top: 19px;
    right: 1em;
    width: 0;
    height: 0;
    border: 5px solid transparent;
    border-color: rgba(25, 22, 50, 0.32) transparent transparent transparent;
  }

  .items {
    color: #14142b;
    border-radius: 0 0 6px 6px;
    overflow: hidden;
    border-right: 1px solid rgba(25, 22, 50, 0.12);
    border-left: 1px solid rgba(25, 22, 50, 0.12);
    border-bottom: 1px solid rgba(25, 22, 50, 0.12);
    position: absolute;
    background-color: #fff;
    left: 0;
    right: 0;
    z-index: 1;
  }

  .items div {
    color: #14142b;
    padding-left: 1em;
    cursor: pointer;
    user-select: none;
  }

  .items div:hover {
    background: #f6f6f6;
  }

  .selectHide {
    display: none;
  }

  .status-1 {
    color: #198754 !important;
  }
  .status-2 {
    color: #0d6efd !important;
  }
  .status-3 {
    color: #dc3545 !important;
  }
  .status-4 {
    color: #bd8f05 !important;
  }
}

.btnBl {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
}
</style>
